/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    EditButton,
    List,
    TextField,
    ReferenceField,
    DateField,
    NumberField,
} from 'react-admin'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function EmployeeLeaveEntitlingAdjustmentList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'document_no', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Employee Leave Entitling/Adjustment" />
                <Datagrid {...props}>
                    <TextField
                        headerClassName={classes.myHeader}
                        source="document_no"
                        label="Entry No"
                    />
                    <DateField
                        label="Document Date"
                        headerClassName={classes.myHeader}
                        source="document_date"
                    />
                    <ReferenceField
                        source="employee_id"
                        reference="PY_EmployeeMasterTAB"
                    >
                        <TextField
                            label="Employee"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>
                    <ReferenceField
                        source="leavetype_id"
                        reference="PY_LeaveTypeTAB"
                    >
                        <TextField
                            label="Leave Type"
                            headerClassName={classes.myHeader}
                            source="description"
                        />
                    </ReferenceField>
                    <NumberField
                        label="Leave Entitled"
                        headerClassName={classes.myHeader}
                        source="leave_entitled"
                    />
                    <NumberField
                        label="Leave Availed"
                        headerClassName={classes.myHeader}
                        source="leave_availed"
                    />
                    <TextField
                        label="Description"
                        headerClassName={classes.myHeader}
                        source="description"
                    />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/PY_EmployeeLeaveCardTAB"
                        />
                    ) : (
                        <EditButton basePath="/PY_EmployeeLeaveCardTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

EmployeeLeaveEntitlingAdjustmentList.defaultProps = {
    quickSearch: false,
}
EmployeeLeaveEntitlingAdjustmentList.propTypes = {
    quickSearch: PropTypes.bool,
}
